import { render, staticRenderFns } from "./takeMsg.vue?vue&type=template&id=0346a3c2&scoped=true&"
import script from "./takeMsg.vue?vue&type=script&lang=js&"
export * from "./takeMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0346a3c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/meiyeJinHuo/meiyeJinHuoAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0346a3c2')) {
      api.createRecord('0346a3c2', component.options)
    } else {
      api.reload('0346a3c2', component.options)
    }
    module.hot.accept("./takeMsg.vue?vue&type=template&id=0346a3c2&scoped=true&", function () {
      api.rerender('0346a3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/balanceCompany/company/takeMsg.vue"
export default component.exports